module.exports = __webpack_public_path__ + "img/issue-icon9.5d787ac.png";